// @flow
import type { RaceStatusEnum } from "@tvg/types/Race";

export type MtpStatus = {
  id: string,
  mtp: number,
  postTime: string,
  trackCode: string,
  trackName: string,
  number: string,
  status: {
    code: RaceStatusEnum
  }
};

type MtpUpdateAction = {
  type: "MTP_STATUS_UPDATE",
  payload: { mtpStatus: MtpStatus[], raceDate: string }
};

export type Actions = MtpUpdateAction;

export const MtpUpdate = (
  mtpUpdate: MtpStatus[],
  raceDate: string
): MtpUpdateAction => ({
  type: "MTP_STATUS_UPDATE",
  payload: { mtpStatus: mtpUpdate, raceDate }
});

export default MtpUpdate;
